import Vue from 'vue'
import Router from 'vue-router'

import {createRouterLayout} from 'vue-router-layout'

import {templateLayouts, templateRoutes} from '@packages/tx-template-system'

Vue.use(Router)

import autoRoutes from 'vue-auto-routing'

const RouterLayout = createRouterLayout(layout => {
    return Promise.resolve(templateLayouts[layout].default);
});


let routes = [
    {
        path: '/template',
        component: RouterLayout,
        children: autoRoutes
    },
];

export default new Router({
    mode: 'abstract',
    routes
})
